import { deleteRequest } from './base';
import constants from '../../config/constants';

export const deleteMethod = (data, payload) => {
    const url = constants.BASE_URL + data;
    return deleteRequest(url, payload);
};
